import React from "react";
export default function JS_Object() {
  return (
    <div className="tutorial-container">
      <h1>JS Object</h1>
      <p>This tutorial explains the concept of JS Object in JavaScript OOPs.</p>
    </div>
  );
}
